export default __webpack_public_path__ + "static/media/handicap-visuel.33a4bf6b.svg";